
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material'

import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

function WarningDialog({ open, onClose, onSubmit, missingClosingDays, missingWorkDays, month, isFlexTimeAccount }) {
    const { t } = useTranslation()
    const sum = missingClosingDays + missingWorkDays;
    const date = month.toLocaleDateString(i18n.language, { month: 'long', year: 'numeric' });

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}

            >
                <DialogTitle>

                    {i18n.language === 'de' ?
                        <p style={{ marginBottom: 0 }}>{sum > 1 ? sum + ' unerfasste Arbeitstage' : ' Ein unerfasster Arbeitstag'} für {date}</p>
                        :
                        <p style={{ marginBottom: 0 }}>{sum > 1 ? sum + ' unrecorded working days' : ' One unrecorded working day'} for {date}</p>
                    }
                </DialogTitle>
                <DialogContent>
                    {i18n.language === 'de' ?
                        <div>
                            <p>Für diesen Monat gibt es noch {missingWorkDays === 1 ? 'einen Arbeitstag' : ''} {missingWorkDays > 1 ? `${missingWorkDays} Arbeitstage` : ''}
                                {missingWorkDays > 0 && missingClosingDays > 0 ? ' und' : ''} {missingClosingDays === 1 ? 'ein Brückentag' : ''} {missingClosingDays > 1 ? `${missingClosingDays} Brückentage` : ''}
                                ohne erfasste Arbeitszeit. Sie lassen sich nach der Freigabe nicht nachträglich erfassen. </p>
                            {isFlexTimeAccount && <p>Hinweis: Dein Arbeitszeitkonto reduziert sich entsprechend der Soll-Arbeitszeit für diese Tage.</p>}
                            <p>Willst du diesen Monat trotzdem freigeben?</p>
                        </div>
                        :
                        <div>
                            <p>There {missingWorkDays === 1 ? 'is one work day' : ''} {missingWorkDays > 1 ? ` are ${missingWorkDays} work days` : ''}
                                {missingWorkDays > 0 && missingClosingDays > 0 ? ' and' : ''} {missingClosingDays === 1 ? 'one closing day' : ''} {missingClosingDays > 1 ? `${missingClosingDays} closing days` : ''}
                                without recorded working times. This can not be edited after the month has been submitted. </p>
                            {isFlexTimeAccount && <p>Note: Your working time account wil be reduced according to the contract working time for these days.</p>}
                            <p>Are you sure you want to submit this month?</p>
                        </div>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>
                        {t('abbrechen', { ns: 'common', defaultValue: 'Abbrechen' })}
                    </Button>
                    <Button variant='contained' onClick={onSubmit}>
                        {t('trotzdemFreigeben', { ns: 'submitsPage', defaultValue: 'Trotzdem Freigeben' })}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default WarningDialog